// Legitimate concierge / tourism service reviews
export const testimonials = [
  {
    id: 1,
    initials: "M.K.",
    location_tr: "İstanbul",
    location_en: "Istanbul",
    rating: 5,
    tr: "Girne'ye iş için gittim. Kıbrıs Night Club konsiyerj servisi havalimanından karşılamadan Cratos rezervasyonuna kadar her şeyi kusursuz koordine etti. Profesyonel diskretlik.",
    en: "I visited Kyrenia on business. Kıbrıs Night Club's concierge team coordinated everything from airport pickup to the Cratos reservation flawlessly. Professional discretion.",
  },
  {
    id: 2,
    initials: "A.T.",
    location_tr: "Ankara",
    location_en: "Ankara",
    rating: 5,
    tr: "Acapulco Resort'ta bir haftalık aile tatilinde iki ayrı gün özel tur rehberi ayarlattım. Konsiyerj ekibi harika bir rehberlik yaptı, ailem çok memnun kaldı.",
    en: "During my one-week family stay at Acapulco Resort I booked private tour guides on two different days. the concierge team did an incredible job — my family loved it.",
  },
  {
    id: 3,
    initials: "R.V.",
    location_tr: "Moskova",
    location_en: "Moscow",
    rating: 5,
    tr: "Yat kiralama paketi harika bir deneyimdi. Şampanya, gün batımı, kaptan koordinasyonu — Rusça rehberlik desteği eşliğinde muhteşemdi.",
    en: "The yacht charter package was an incredible experience. Champagne, sunset, captain coordination — combined with Russian-language guidance support, magnificent.",
  },
  {
    id: 4,
    initials: "J.S.",
    location_tr: "Londra",
    location_en: "London",
    rating: 5,
    tr: "İngilizce iletişim, hızlı yanıt, premium kalite. Girne'de tanıştığım en profesyonel konsiyerj servisi. Etiket rehberliği paha biçilmezdi.",
    en: "English communication, fast reply, premium quality. The most professional concierge service I've encountered in Kyrenia. The etiquette guidance was priceless.",
  },
  {
    id: 5,
    initials: "K.O.",
    location_tr: "Kiev",
    location_en: "Kyiv",
    rating: 5,
    tr: "Restoran rezervasyonu ve akşam yemeği koordinasyonu iş partnerlerimle görüşmemin ardından mükemmel bir kapanış oldu.",
    en: "The restaurant reservation and dinner coordination after my business meeting was the perfect closing.",
  },
  {
    id: 6,
    initials: "H.B.",
    location_tr: "Berlin",
    location_en: "Berlin",
    rating: 5,
    tr: "Merit Crystal Cove'da 3 gece kaldım. Konsiyerj ekibinin şehir turu ve casino etiket rehberliği çok değerliydi. %100 diskretlik.",
    en: "I stayed 3 nights at Merit Crystal Cove. The concierge team's city tour and casino etiquette guidance were invaluable. 100% discretion.",
  },
];
